import { type Plugin } from 'vue';
import { SnackbarService } from 'vue3-snackbar';

const snackbar: Plugin = SnackbarService;

export default snackbar;
